import "select2";

(function( $ ) {

	"use strict";
	
	// javascript code here. i.e.: $(document).ready( function(){} ); 
    $(document).ready(function() {
        let select = $('select').not('.woocommerce .checkout .form-row select, .woocommerce-shipping-totals  select');
        select.select2({
            minimumResultsForSearch: Infinity,
        });

        $('#formModal').on('shown.bs.modal', function () {
            // Destroy any existing Select2 instance first, then reinitialize
            $('select').select2({
                minimumResultsForSearch: -1,
                dropdownParent: $('#formModal .modal-content'),
                width: '100%'
            });
        });
    });
})(jQuery);